import { render, staticRenderFns } from "./NewList.vue?vue&type=template&id=d56f6990"
import script from "./NewList.vue?vue&type=script&lang=ts"
export * from "./NewList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports